import {gsap, Sine} from 'gsap'
import SplitText from '../assets/gsap/esm/SplitText.js'

// prepare for split text 
function setSplitText( $container ){
  var $splitArray = $container.querySelectorAll('.split');

  if( $splitArray.length < 0 ){
    return;
  }
  gsap.set($splitArray,{
    opacity: 0,
  });
}


function splitText( $container, delay = 0 ){
  var $splitArray = $container.querySelectorAll('.split');

  if( $splitArray.length < 0 ){
    return;
  }
  gsap.set($splitArray,{
    opacity: 0,
  });

  // spit text in single words 
  var split = new SplitText( $splitArray ,{ type:'words, lines' });
  var eachTime = 0.08;

  if( !split ){
    return;
  }

  // hide splittet text
  gsap.set(split.lines, {
      opacity: 0,
      scale: 1.3,
      transformOrigin:'0% 0%'
    });

    // reapear splittet text
    gsap.to(split.lines, {
      duration: 0.5,
      delay: delay,
      opacity: 1,
      scale: 1,
      stagger: eachTime,
      ease: Sine.easeOut,
      onStart: function(){
        gsap.set( $splitArray, {opacity: 1});
      },  
      onComplete: function(){
        split.revert(); // remove split text on complete
      }
    });
  
}

export { splitText, setSplitText };
